import { createElement, type ElementType, type ReactNode } from "react";

export function Container({
  as: Tag = "div",
  className = "",
  children,
  ...rest
}: {
  as?: ElementType;
  className?: string;
  children: ReactNode;
  [key: `data-${string}`]: string | boolean | undefined;
}) {
  return createElement(
    Tag,
    { className: `mx-auto w-full max-w-[80rem] px-6 sm:px-8 lg:px-12 ${className}`, ...rest },
    children
  );
}
